module.exports = {
      id: "prayer-header-usage",
      viewBox: "0 0 300 193",
      url: "/" + "svg-sprite-475344759687326ca60b708b4aa20d33.svg#prayer-header",
      toString: function () {
        return this.url;
      }
    }